<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      Fælles kommentarer
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" >
    @if(form.disabled) {
      <dl fxFlex="45" class="settings-list">
        <dt>Delte kommentartråde?</dt>
        <dd>{{value.shared ? 'Ja' : 'Nej'}}</dd>
      </dl>
    } @else {
      <div fxFlex="45">
        <form [formGroup]="form">
          <mat-checkbox ngDefaultControl  formControlName="shared">Del kommentartråde</mat-checkbox>
        </form>
      </div>
    }
    <mat-divider [vertical]="true"></mat-divider>
    <div fxFlex="45">
      <p>Hvis fonden har <em>delte kommentartråde</em> slået til kan alle brugere med adgang til fælles kommentarer se alle tråde - både dem de deltager I og dem de ikke deltager i.</p>
    </div>
  </div>
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button class="action-edit" (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button class="action-cancel" (click)="doCancel()">Fortryd</button>
        <button mat-flat-button class="action-save" (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
